<template id="countdown-template">
	<div class="col-12 pb-3 pt-3 background-white-dark shadow-sm">
		<div class="row">
			<div class="col-12 text-center color-black">
				Sisa Waktu Pembayaran
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center font-size-20 color-black f-lato">
				<span> {{hours | two_digits}} </span> : <span> {{minutes | two_digits}} </span> : <span> {{seconds | two_digits}} </span>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center color-black">
				<span class="pr-1 pl-3">Jam</span><span class="pr-1 pl-3">Menit</span><span class="pr-1 pl-3">Detik</span>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center font-size-11 font-size-sm-10 color-black pt-2 f-lato">
				(Sebelum {{ date | hariTanggalJam }})
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		date: {
			type: String
		}
	},
	data() {
		return {
			now: Math.trunc((new Date()).getTime() / 1000)
		}
	},
	computed: {
		dateInMilliseconds() {
			return Math.trunc(Date.parse(this.date) / 1000)
		},
		seconds() {
			if(this.date){
				return (this.dateInMilliseconds - this.now) % 60;
			}
			else{
				return 59
			}
		},
		minutes() {
			if(this.date){
				return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
			}
			else{
				return 59
			}
		},
		hours() {
			if(this.date){
				return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60);
			}
			else{
				return 23
			}
			
			// return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
		},
		days() {
			return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
		}
	},
	mounted() {
		window.setInterval(() => {
			this.now = Math.trunc((new Date()).getTime() / 1000);
		}, 1000);
	},
}
</script>

<style>

</style>